import BackendConnector from './backendConnector';

export default class EmployerJobCandidatesHttpService {
    static getCandidates({
        employerId,
        positionId,
        workflowStep,
        pageOptions = { page: 0, size: 0, skip: 0 },
        filter,
        skipTalentIds = false,
        isListView = false,
        useExplain = false,
        userLinkedinId,
        increaseRefreshPeriod = false,
        locationCandidatesIds = null,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/candidates`, {
            pageOptions: {
                page: pageOptions.page,
                size: pageOptions.size,
                skip: pageOptions.skip,
            },
            filter,
            skipTalentIds,
            isListView,
            useExplain,
            userLinkedinId,
            increaseRefreshPeriod,
            locationCandidatesIds,
        });
    }

    static getCandidatesManualQualify({
        employerId,
        positionId,
        pageOptions = { page: 0, size: 0, skip: 0 },
        filter,
        skipTalentIds = false,
        isListView = false,
        useExplain = false,
        userLinkedinId,
        increaseRefreshPeriod = false,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/getCandidatesForManualQualify`, {
            pageOptions: {
                page: pageOptions.page,
                size: pageOptions.size,
                skip: pageOptions.skip,
            },
            filter,
            skipTalentIds,
            isListView,
            useExplain,
            userLinkedinId,
            increaseRefreshPeriod,
        });
    }

    static getCandidatesByTalentIds({
        employerId,
        positionId,
        talentIds,
        isExportMode = false,
        isListView = false,
        useExplain = false,
        includeContacts = true,
        needPositionApprovalPageUrls = false,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/candidates`, {
            talentIds,
            isListView,
            isExportMode,
            useExplain,
            includeContacts,
            needPositionApprovalPageUrls,
        });
    }

    static getCandidate({
        employerId, positionId, workflowStep, talentId, filter, useExplain = false, userLinkedinId,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/candidate/${talentId}`, {
            filter,
            useExplain,
            userLinkedinId,
        });
    }

    static async getCandidatesExplain({ talentIDs, positionId, isSamples }) {
        return BackendConnector.post('/talentScore/explain', {
            talentIDs,
            positionId,
            isSamples,
        });
    }

    static async getPotentialAutoContactCandidatesData(positionId) {
        return BackendConnector.post(`/position/${positionId}/getPotentialAutoContactCandidatesData`);
    }

    static async getEmployerCandidatesCounters({ employerId, positionId, talentIds }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/candidatesCounters`, { talentIds });
    }

    static async getEmployerCandidatesFilterCounters({
        employerId, positionId, workflowStep, userLinkedinId,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/filterCounters`, {
            userLinkedinId,
        });
    }

    static getEmployerWorkflowStepCandidatesCounters({
        employerId,
        positionId,
        workflowStep,
        pageOptions = { page: 0, size: 0, skip: 0 },
        filter,
        skipTalentIds = false,
        isListView = false,
        useExplain = false,
        userLinkedinId,
    }) {
        return BackendConnector.post(`/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/counters`, {
            pageOptions: {
                page: pageOptions.page,
                size: pageOptions.size,
                skip: pageOptions.skip,
            },
            filter,
            skipTalentIds,
            isListView,
            useExplain,
            userLinkedinId,
        });
    }
}
